import React from 'react';

export const ReadyOverlay: React.FC = ({ children }) => <>{React.Children.only(children)}</>;
